import {
  BaseQueryApi,
  BaseQueryExtraOptions,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryArgs,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query';

import { getApiPassword, rejectApiPassword } from '@/lib/api-password';

const AUTH_ERROR_CODES = [401];

export const baseQueryWithReauth =
  (config: FetchBaseQueryArgs) =>
  async (
    args: FetchArgs | string,
    api: BaseQueryApi,
    extraOptions: BaseQueryExtraOptions<BaseQueryFn>,
  ) => {
    const result = await fetchBaseQuery(config)(args, api, extraOptions);
    if (result.error && AUTH_ERROR_CODES.includes(result.error.status as number)) {
      // the stored password is wrong or revoked — drop it so the gate asks for a new one
      rejectApiPassword();
    }

    return result;
  };

export const BASE_QUERY_WITH_AUTH = baseQueryWithReauth({
  baseUrl: process.env.REACT_APP_BACKEND_BASE_URL,
  credentials: 'include',
  mode: 'cors',
  prepareHeaders: (headers) => {
    headers.set('x-sec-password', getApiPassword());

    return headers;
  },
});
